import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog";
import Slide from "@material-ui/core/Slide";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel ,
  TablePagination,
  Typography,
  IconButton,
  Paper,
  Button,
  Chip
} from "@material-ui/core";
import SearchBox from "./Products/SearchBox";
import ScoreBox from "./Products/ScoreBox";
import axios from "axios";
import envConfig from "../../bin/env.config";
import store from "../../store/store";
import ButtonSelectGroupId from "./Products/ButtonSelectGroupId";
import ButtonSelectCompetitorGroupId from "./CompetitorProducts/ButtonSelectCompetitorGroupId";
import ProductAttributesInfo from "../Product/ProductAttributesInfo";
import CompanyDropDownBox from "../ProductMatching/CompanyDropDownBox";
// import { Helpers } from "../../../../utility/helpers";
import { useSelector } from "react-redux";
import CircularProgress from '@material-ui/core/CircularProgress';
import VizSensor from "react-visibility-sensor";
import CompanyLogo from "../Common/CompanyLogo";
// import ProductDetail from './ProductDetail';
import ProductImage from "../Common/ProductImage";

const useStyles = makeStyles((theme) => ({
  appBar: {
    position: "relative",
  },
  grow: {
    flexGrow: 1,
  },
  title: {
    //marginLeft: theme.spacing(2),
    flex: 1,
  },
  dialogPaper: {
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
  },
  content: {
    flex: 1,
    minHeight: 0,
    display: "flex",
    flexDirection: "column",
    padding: theme.spacing(2, 4),
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(1, 2),
    },
  },
  productInfo: {
    flexShrink: 0,
    textAlign: "left",
    marginBottom: theme.spacing(1.5),
    padding: theme.spacing(1.5, 2),
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 8,
    backgroundColor: "#fafafa",
  },
  productTitle: {
    margin: 0,
    fontSize: "1.1rem",
    fontWeight: 600,
    lineHeight: 1.3,
  },
  productMeta: {
    marginTop: theme.spacing(0.25),
    color: theme.palette.text.secondary,
    fontSize: "0.85rem",
  },
  productField: {
    display: "grid",
    gridTemplateColumns: "92px 1fr",
    columnGap: theme.spacing(1),
    alignItems: "start",
    marginTop: theme.spacing(0.75),
    fontSize: "0.875rem",
    lineHeight: 1.45,
  },
  productFieldLabel: {
    color: theme.palette.text.secondary,
    fontWeight: 600,
  },
  productFieldValue: {
    minWidth: 0,
    overflowWrap: "anywhere",
  },
  productDescription: {
    maxHeight: 64,
    overflowY: "auto",
    whiteSpace: "pre-wrap",
  },
  keywordChip: {
    margin: theme.spacing(0, 0.5, 0.5, 0),
    height: 22,
    fontSize: "0.75rem",
  },
  productHint: {
    marginTop: theme.spacing(1),
    color: theme.palette.error.main,
    fontStyle: "italic",
    fontSize: "0.8rem",
  },
  tableContainer: {
    flex: 1,
    minHeight: 0,
    overflow: "auto",
  },
  stickyCell: {
    backgroundColor: theme.palette.background.paper,
    zIndex: 3,
  },
  pagination: {
    flexShrink: 0,
    borderTop: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.background.paper,
  },
  table: {
    minWidth: 350,
    "& tbody>.MuiTableRow-root:hover": {
      background: "#DDD",
    },
  },
  potentialProductImage: {
    width: 50,
    height: 50,
    marginRight: theme.spacing(1),
    [theme.breakpoints.down("sm")]: {
      width: 25,
      height: 25,
    },
    // cursor: "pointer",
  },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="right" ref={ref} {...props} />;
});

const getKeywordList = (keyWords) =>
  String(keyWords || "")
    .split(/[,;]+/)
    .map((word) => word.trim())
    .filter(Boolean);

export function RowItem(props){
  const {product, row, reloadData,row_number,isCompetitor,onSelectedSuccess} = props;   
  return (    
          <TableRow>              
                <TableCell align="left">{row_number+1}</TableCell>
                <TableCell align="left">
                  {!isCompetitor&&<ButtonSelectGroupId product={product} potentialProduct={row}  reloadData={reloadData} onSelectedSuccess={onSelectedSuccess}/>} 
                  {isCompetitor&&<ButtonSelectCompetitorGroupId product={product} potentialProduct={row}  reloadData={reloadData} onSelectedSuccess={onSelectedSuccess}/>} 
                </TableCell>
                <TableCell align="left">{row.id}</TableCell>
                <TableCell >
                    <ProductImage product_id={row.id}
                      title={row.name} width={'50px'} height={'50px'} hide_multiple_icon="true"
                    />
                </TableCell>
                <TableCell align="left">
                  {row.name}
                  <ProductAttributesInfo productId={row.id}/>
                </TableCell>
                <TableCell align="left">{row.size}</TableCell>
                <TableCell align="left">{row.brand}</TableCell>  
                <TableCell align="center">  
                  <CompanyLogo company_id={row.company_id}
                                    // alt={productMatch.company_name}
                                    style={{ height: "50px" }}                  
                                  />                    
                </TableCell>                                
          </TableRow>  
  )
}
export default function DialogFindGroupId(props) {
  const classes = useStyles();
  const { open, onClose, product, reloadData, isCompetitor} = props;
  const handleSelectedSuccess = () => {
    onClose && onClose();
  };
  const [isLoading, setIsLoading] = useState(false);
  const [scoreValue, setScoreValue] = useState('0.4');
  const [searchText, setSearchText] = useState(product.name);
  const [searchName, setSearchName] = useState('');
  const [searchSize, setSearchSize] = useState('');
  const [searchBrand, setSearchBrand] = useState('');
  
  const [searchType, setSearchType] = useState(2);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(100);
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("id");
  const [groupOnly, setGroupOnly] = useState(false);
  const [dataSource, setDataSource] = useState([]);
  const [totalCount, setTotalCount] = useState(0);

  const companies = useSelector(state => state.companies.companies);
  const selectedCompany = companies&&companies.find(company=>company.selected);
  
  useEffect(() => {
    // const controller = new AbortController();
    const fetchData = async () => {
      setIsLoading(true);
      const skip = page * rowsPerPage;
      const url = `${envConfig.API_ROOT}${envConfig.API_VERSION}/company-report-tool/find-group_id?orderBy=${orderBy}&order=${order}&limit=${rowsPerPage}&skip=${skip}&c=${selectedCompany?selectedCompany._id:0}`;
      const result = await axios.post(
        url,
        { q: searchText,
          name: searchName,
          size: searchSize,
          brand: searchBrand,
          searchType: searchType, score:scoreValue, cproduct_id: product.id, is_competitor: isCompetitor,groupOnly: groupOnly},
        {
          // signal:controller.signal,
          headers: {
            Authorization: JSON.stringify(store.getState().session.token),
          },
        }
      );

      setDataSource(result.data.data);
      
      // If API returns total count, use it; otherwise estimate from data length
      if (result.data.total !== undefined) {
        setTotalCount(result.data.total);
      } else if (result.data.count !== undefined) {
        setTotalCount(result.data.count);
      } else {
        // Estimate: if we got full page, there might be more
        setTotalCount(result.data.data.length < rowsPerPage ? (page * rowsPerPage + result.data.data.length) : (page + 1) * rowsPerPage + 1);
      }
      
      setIsLoading(false);
    };
    open&&fetchData();
    // return () => controller.abort();
  }, [searchText,searchName,searchSize,searchBrand, searchType, scoreValue, page, rowsPerPage, order, orderBy, groupOnly, open, selectedCompany]);
  const doSearch = (q) => {
    setSearchText(q);
    setSearchName('');
    setSearchSize('');
    setSearchBrand('');
    setPage(0);
  };
  const doSearchSize = (size) => {
    setSearchSize(size);
    setPage(0);
  };
  const doSearchName = (name) => {
    setSearchName(name);
    setPage(0);
  };
  const doSearchBrand = (brand) => {
    setSearchBrand(brand);
    setPage(0);
  };
  const doChangeScore = (score) => {
    setScoreValue(score);
    setPage(0);
  };
  
  const handleSearchTypeChange = (event) => {
    setSearchType(event.target.value);
    setPage(0);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const keywordList = product ? getKeywordList(product.key_words) : [];
  
  return (
    <Dialog
      fullScreen
      open={open}
      onClose={onClose}
      TransitionComponent={Transition}
      PaperProps={{ className: classes.dialogPaper }}
    >
      <AppBar position="relative" color="inherit" className={classes.appBar}>
          <Toolbar>
            <IconButton
              color="inherit"
              onClick={onClose}
              aria-label="Close"
            >
              <ArrowBackIcon />
            </IconButton>
            <Typography className={classes.title} variant="h6" noWrap>
             {/* {product.brand} {product.name} {product.size} */}
             {isCompetitor?'Find a competitor/similar products on BetterCart':'Find a product on BetterCart'}
            </Typography>  
            <div className={classes.grow} />
            <FormControlLabel
                control={
                  <Checkbox
                    checked={groupOnly}
                    onChange={() => setGroupOnly(!groupOnly)}
                    name="groupOnly"
                    color="secondary"
                  />
                }
                label="GroupOnly"
             />
            <Select  value={searchType} onChange={handleSearchTypeChange}>
              <MenuItem value="1">
                <em>Elastic Search</em>
              </MenuItem>
              <MenuItem value="2">
                <em>PostgreSQL Similar</em>
              </MenuItem>
              <MenuItem value="4" >
                <em>PostgreSQL ilike</em>
              </MenuItem>
              <MenuItem value="5" >
                <em>PostgreSQL ilike Attributes</em>
              </MenuItem>
              <MenuItem value="3" >
                <em>ML Predictions</em>
              </MenuItem>
              <MenuItem value="6">
                <em>PostgreSQL tsvector</em>
              </MenuItem>
            </Select>
            <CompanyDropDownBox/>
            {searchType==3&&(
              <ScoreBox value={scoreValue} doChangeScore={doChangeScore}/>
            )} 
            <SearchBox value={searchText} doSearch={doSearch} searchOnChange={false} placeholder="Search for the product group to use"/>
          </Toolbar>
        </AppBar>
        <div className={classes.content}>
          {product && (
            <div className={classes.productInfo}>
              <Typography className={classes.productTitle} component="h3">
                {product.name}
              </Typography>
              {/* <div className={classes.productMeta}>
                {[product.brand, product.size].filter(Boolean).join(" · ") || "—"}
              </div> */}
              <div className={classes.productField}>
                <span className={classes.productFieldLabel}>Key words</span>
                <div className={classes.productFieldValue}>
                  {keywordList.length > 0 ? (
                    keywordList.map((word, index) => (
                      <Chip
                        key={`${word}-${index}`}
                        label={word}
                        size="small"
                        variant="outlined"
                        className={classes.keywordChip}
                      />
                    ))
                  ) : (
                    "—"
                  )}
                </div>
              </div>
              <div className={classes.productField}>
                <span className={classes.productFieldLabel}>Description</span>
                <div className={`${classes.productFieldValue} ${classes.productDescription}`}>
                  {product.description || "—"}
                </div>
              </div>
              <div className={classes.productHint}>
                If you don't see any results, please check the settings for banners and cities.
              </div>
            </div>
          )}
          <TableContainer component={Paper} className={classes.tableContainer}>
            <Table className={classes.table} stickyHeader aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell align="left" className={classes.stickyCell}>
                    #
                  </TableCell>
                  <TableCell align="left" className={classes.stickyCell}>
                    Group Id
                  </TableCell>
                  <TableCell align="left" className={classes.stickyCell}>
                    Product Id
                  </TableCell>
                  <TableCell align="left" className={classes.stickyCell}>
                    Image
                  </TableCell>
                  <TableCell align="left" className={classes.stickyCell}>
                    Name
                    <SearchBox value={searchName} doSearch={doSearchName} searchOnChange={false} placeholder="Name"/>
                  </TableCell>
                  <TableCell align="left" className={classes.stickyCell}>
                    Size
                    <SearchBox value={searchSize} doSearch={doSearchSize} searchOnChange={false} placeholder="Size"/>
                  </TableCell>
                  <TableCell align="left" className={classes.stickyCell}>
                    Brand
                    <SearchBox value={searchBrand} doSearch={doSearchBrand} searchOnChange={false} placeholder="Brand"/>
                  </TableCell>
                  <TableCell align="center" className={classes.stickyCell}>
                    Company
                  </TableCell>
                </TableRow>
              </TableHead>
              {isLoading ? (
                <TableBody>
                  <TableRow>
                    <TableCell colSpan={8} align="center"><CircularProgress size={16} /></TableCell>
                  </TableRow>
                </TableBody>
              ) : (
              <TableBody>
                {dataSource.map((row, i) => (
                  <RowItem key={i} product={product} row={row} reloadData={reloadData} row_number={page * rowsPerPage + i} isCompetitor={isCompetitor} onSelectedSuccess={handleSelectedSuccess}/>
                ))}
                {dataSource.length === 0 && !isLoading && (
                  <TableRow>
                    <TableCell colSpan={8} align="center">
                      <Typography color="textSecondary">No data found</Typography>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
              )}
            </Table>
          </TableContainer>
          <TablePagination
            className={classes.pagination}
            component="div"
            count={totalCount}
            page={page}
            onPageChange={handleChangePage}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            rowsPerPageOptions={[10, 20, 50, 100]}
          />
        </div>
    </Dialog>
  );
}
